import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAcl, type SystemRole } from '@/hooks/useAcl';
import { getRoleHomeRoute } from '@/router/roleRoutes';
import type { AclFeature } from '@/mocks/aclPermissions';

interface RouteGuardProps {
  feature: AclFeature;
  /**
   * Restricts a route to specific roles on top of the feature check. Every role
   * shares the `dashboard` feature, so this is what keeps a therapist off the
   * admin dashboard. Pass values from `getRolesForRoute` so the redirect target
   * always satisfies its own guard.
   */
  allowedRoles?: readonly SystemRole[];
  children: ReactNode;
}

export default function RouteGuard({ feature, allowedRoles, children }: RouteGuardProps) {
  const { role, canView } = useAcl();

  if (!canView(feature)) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={getRoleHomeRoute(role)} replace />;
  }

  return <>{children}</>;
}
